import React from 'react';
import Summary from '../../summary/summary.component';

import Insight from '../../insight/insight.component';
import { sortObjectArrayDesc } from '../../../utils/helper';
import Timeline from './../../timeline/timeline.component';


const WorldDashboard = ({ match }) => {
  const param = match.params.countrycode;
  console.log('countryParam', param);

  let insight = null;

  if (typeof (param) === 'undefined' || param === 'US') {
    insight = <Insight param={param} />;
  }
  return (
    <div className="datagrid">
      <Summary param={param} />
      <Timeline param={param} />
      {
        insight
      }
    </div>
  );
}

export default WorldDashboard;